import { createContext, useContext, useState, ReactNode } from "react";

interface PreviewModeContextValue {
  previewMode: boolean;
  toggle: () => void;
}

const PreviewModeContext = createContext<PreviewModeContextValue>({
  previewMode: false,
  toggle: () => {},
});

export function PreviewModeProvider({ children }: { children: ReactNode }) {
  const [previewMode, setPreviewMode] = useState(false);
  return (
    <PreviewModeContext.Provider value={{ previewMode, toggle: () => setPreviewMode((p) => !p) }}>
      {children}
    </PreviewModeContext.Provider>
  );
}

export function usePreviewMode() {
  return useContext(PreviewModeContext);
}
